import { render, staticRenderFns } from "./follow-record-case-status.vue?vue&type=template&id=3e2a3f3b&scoped=true"
import script from "./follow-record-case-status.vue?vue&type=script&lang=ts"
export * from "./follow-record-case-status.vue?vue&type=script&lang=ts"
import style0 from "./follow-record-case-status.vue?vue&type=style&index=0&id=3e2a3f3b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e2a3f3b",
  null
  
)

export default component.exports